import axios from 'utils/axios'

export const select = (kind) => {
  const endpoint = `/multi-calendar-sync/select/${kind}`
  return axios.post(endpoint)
}
